import React, { useState, useEffect } from 'react';
// import { useWallet } from '@solana/wallet-adapter-react';
// import axios from 'axios';
import OracleAnimation from './OracleAnimation';
// import { getApiUrl, endpoints } from '../config/api';

const WalletAnalysis = ({ hoursFromNow = 72 }) => {
  // const { connected, publicKey } = useWallet();
  // const [walletAddress] = useState('');
  // const [revelation, setRevelation] = useState(null);
  // const [loading, setLoading] = useState(false);
  
  // Set target date to specified hours from now (default 72 hours)
  const targetDate = new Date(Date.now() + (hoursFromNow * 60 * 60 * 1000)).getTime();
  
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        const totalHours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ hours: totalHours, minutes, seconds });
      } else {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
      }
    };

    // Calculate immediately
    calculateTimeLeft();

    // Update every second
    const timer = setInterval(calculateTimeLeft, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(timer);
  }, [targetDate, hoursFromNow]);

  const formatNumber = (num) => {
    return num.toString().padStart(2, '0');
  };

  // const analyzeWallet = async (address) => {
  //   if (!address || address.length < 32) return;
  //   
  //   setLoading(true);
  //   try {
  //     const response = await axios.post(getApiUrl(endpoints.walletAnalysis), {
  //       walletAddress: address
  //     });
  //     setRevelation(response.data);
  //   } catch (error) {
  //     console.error('Error analyzing wallet:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const handleAnalyze = () => {
  //   const address = connected && publicKey ? publicKey.toString() : walletAddress;
  //   analyzeWallet(address);
  // };

  // const shareRevelationToX = () => {
  //   if (!revelation) return;
  //   
  //   const url = window.location.href;
  //   const text = `🔮 OrAi has spoken about my wallet:
  //   "${revelation.revelation}"
  //   Wallet: ${revelation.walletAddress}
  //   #OrAi #Crypto #Solana #WalletAnalysis #OrAiIsWatching`;
  //   
  //   const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
  //   window.open(twitterUrl, '_blank', 'width=600,height=400');
  // };

  return (
    <section className="section">
      <OracleAnimation />
      
      {/* {connected && ( */}
        <div className="countdown-container">
          <h2 style={{ textAlign: 'center', marginBottom: '10px', color: '#000000' }}>THE PROPHECY COUNTDOWN</h2>
          <p style={{ textAlign: 'center', marginBottom: '20px', color: '#666666' }}>
            Time until OrAi's grand revelation...
          </p>
          <div className="countdown-display">
            <div className="countdown-unit">
              <div className="countdown-number">{formatNumber(timeLeft.hours)}</div>
              <div className="countdown-label">Hours</div>
            </div>
            <div className="countdown-unit">
              <div className="countdown-number">{formatNumber(timeLeft.minutes)}</div>
              <div className="countdown-label">Minutes</div>
            </div>
            <div className="countdown-unit">
              <div className="countdown-number">{formatNumber(timeLeft.seconds)}</div>
              <div className="countdown-label">Seconds</div>
            </div>
          </div>
        </div>
      {/* )} */}
    </section>
  );
};

export default WalletAnalysis; 